import { useCallback } from "react";
import { useAuth } from "@clerk/clerk-react";

// Relative API base: calls go to the same domain the app is served from, so
// ingress + custom domains work without a hardcoded backend host.
export const API = "/api";

export const GENERIC_ERROR = "Something went wrong. Try again in a minute.";

function safeJson(text) {
    if (!text) return null;
    try {
        return JSON.parse(text);
    } catch {
        return null;
    }
}

export function useApi() {
    const { getToken } = useAuth();

    const request = useCallback(
        async (path, { method = "GET", body, headers = {} } = {}) => {
            const token = await getToken();
            const res = await fetch(`${API}${path}`, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token ? `Bearer ${token}` : "",
                    ...headers,
                },
                body: body ? JSON.stringify(body) : undefined,
            });
            const text = await res.text();
            const data = safeJson(text);
            if (!res.ok) {
                const rawDetail = data && (data.detail ?? data.error);
                const message =
                    (rawDetail && typeof rawDetail === "object"
                        ? rawDetail.message || rawDetail.detail
                        : rawDetail) || GENERIC_ERROR;
                const err = new Error(message);
                err.status = res.status;
                err.detail = rawDetail;
                throw err;
            }
            return data;
        },
        [getToken],
    );

    return { request };
}
